import React from 'react';
import Seals from './Seals';

export default function ProductShowcase() {
  return (
    <section id="aboutourcoffee" className="relative py-20 lg:py-28 overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Header: headline left, lede right, so the section doesn't open on the same centered stack as the others */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-end mb-16 lg:mb-20">
            <div className="lg:col-span-7">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-4">Our Coffee</p>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-gray-900">
                Moonshine Coffee, <span className="text-clay">grown in Nabutaka</span>
              </h2>
            </div>
            <p className="lg:col-span-5 text-lg text-gray-700 leading-relaxed">
              Our own Robusta, grown and processed at Mubarak Farm. We run every step from planting to export, so each bag is fresh and traceable to the field it came from.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="flex flex-col items-center gap-8">
              <img
                className="w-full max-w-md h-auto object-contain rounded-3xl"
                src="/flow-assets/content/moonshine-coffee.webp"
                alt="Moonshine Coffee bag, Ugandan Robusta, medium roast"
                width={1632}
                height={2592}
                loading="lazy"
              />
              <Seals className="w-full max-w-md" />
            </div>

            {/* Product Info */}
            <div className="flex flex-col">
              {/* Plain text labels, no pills */}
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-4">
                Single origin · SC-12 / 15 / 18
              </p>

              <h3 className="font-heading text-3xl lg:text-4xl text-gray-900 mb-4">
                What makes it different
              </h3>

              <p className="text-gray-700 text-lg mb-10 max-w-xl">
                Grown and processed on one farm in Nabutaka. The same hands that planted the trees also raked the drying beds and packed the sacks.
              </p>

              {/* Features as a typographic list */}
              <dl className="mb-10 divide-y divide-gray-300/70 border-y border-gray-300/70">
                <div className="grid grid-cols-12 gap-4 py-5">
                  <dt className="col-span-5 sm:col-span-4 text-clay font-heading text-lg lg:text-xl">Single estate</dt>
                  <dd className="col-span-7 sm:col-span-8 text-gray-700 leading-snug">One farm in Nabutaka. No middlemen, no lot-mixing.</dd>
                </div>
                <div className="grid grid-cols-12 gap-4 py-5">
                  <dt className="col-span-5 sm:col-span-4 text-clay font-heading text-lg lg:text-xl">Hand sorted</dt>
                  <dd className="col-span-7 sm:col-span-8 text-gray-700 leading-snug">Graded into Screen 12, 15, and 18. Each grade is uniform within itself.</dd>
                </div>
                <div className="grid grid-cols-12 gap-4 py-5">
                  <dt className="col-span-5 sm:col-span-4 text-clay font-heading text-lg lg:text-xl">Fully traceable</dt>
                  <dd className="col-span-7 sm:col-span-8 text-gray-700 leading-snug">Every batch links back to its row, harvest date, and drying bed.</dd>
                </div>
                <div className="grid grid-cols-12 gap-4 py-5">
                  <dt className="col-span-5 sm:col-span-4 text-clay font-heading text-lg lg:text-xl">Small batch</dt>
                  <dd className="col-span-7 sm:col-span-8 text-gray-700 leading-snug">Roasted in lots small enough to ship the same week they leave the drum.</dd>
                </div>
              </dl>

              <a
                href="#howtoorder"
                className="inline-flex items-center justify-center gap-3 bg-gray-900 hover:bg-clay text-white font-bold px-8 py-4 rounded-full transition-[background-color,transform] duration-200 w-fit active:scale-[0.97]"
              >
                <span>See how to order</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
